import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsIntegrationDetails from "./components/SettingsIntegrationDetails";

const SettingsIntegrationDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsIntegrationDetails {...props} />
    </>
  );
};

export default SettingsIntegrationDetailsApp;
